import { useNavigate, useParams, useLocation } from 'react-router-dom';
import IntroduceBroker from './IntroduceBroker';

export default function IntroduceBrokerWrapper(props: any) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    return (
        <IntroduceBroker
            {...props}
            navigate={navigate}
            params={params}
            location={location}
        />
    );
}
